import { customTheme } from 'theme/theme';

export const LINE_HEIGHT = 1.1;
export const STATUS_COLORS = {
  PENDING: customTheme.colors.primary,
  APPROVED: customTheme.colors.green,
  REJECTED: customTheme.colors.red[5],
  DELETED: customTheme.colors.secondary,
};
